/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Fragment } from 'react';
import PartnerShowcaseCard from '../../shared/cards/PartnerShowcaseCard';
const PartnerShowcaseContent = ({ items }) => {
    function renderCard(item) {
        const ItemComponent = PartnerShowcaseCard;
        return React.createElement(ItemComponent, Object.assign({}, item, { key: item.id }));
    }
    return React.createElement(Fragment, null, items.map((item) => renderCard(item)));
};
export default PartnerShowcaseContent;
